import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Field, { fieldTypes } from "components/Field";
import { modalTypes } from "constants/types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { changePassword } from "slices/app/actions/app";
import { hideModal } from "slices/app/actions/modals";

const ChangePasswordModal = () => {
  const dispatch = useDispatch();

  const [oldPassword, setOldPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const isEnabled = () =>
    oldPassword &&
    newPassword &&
    confirmPassword &&
    oldPasswordError === "" &&
    newPasswordError === "" &&
    confirmPasswordError === "";

  const handleOk = () => {
    if (isEnabled()) {
      dispatch(changePassword(oldPassword, newPassword));
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.CHANGE_PASSWORD));
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter") {
      handleOk();
    }
  };

  return (
    <Modal
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header>
        <b>Change Password</b>
      </Modal.Header>
      <Modal.Body>
        <div className="change_password__modal">
          <Field
            type={fieldTypes.password}
            propsObject={{
              password: oldPassword,
              setPassword: setOldPassword,
              passwordError: oldPasswordError,
              setPasswordError: setOldPasswordError,
              labelText: "Old Password",
            }}
          />

          <Field
            type={fieldTypes.passwordAndConfirm}
            propsObject={{
              password: newPassword,
              setPassword: setNewPassword,
              passwordError: newPasswordError,
              setPasswordError: setNewPasswordError,
              confirmPassword,
              setConfirmPassword,
              confirmPasswordError,
              setConfirmPasswordError,
              passwordLabelText: "New Password", // NOSONAR javascript:S2068 - label text for a password field, not a hardcoded credential
              confirmLabelText: "Confirm New Password",
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-test="saveButton"
          variant={NewButtonVariant.l1}
          onClick={handleOk}
          disabled={!isEnabled()}
        >
          Ok
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;
